import React, { useRef, useEffect } from "react";
import {
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  Slider,
  FormControl,
  useMediaQuery,
} from "@mui/material";
import ReactPlayer from "react-player";
import { useTheme } from "@mui/material/styles";
import { H3, H5, H6 } from "../../components/typography";
import { COLORS } from "../../theme";
import LargeOption from "./largeoption";
import Timeline from "./timeline";

const QuizContent = (props) => {
  const [sliderValue, setSliderValue] = React.useState(0);
  const [screenSize, setScreenSize] = React.useState(getCurrentDimension());
  const [value, setValue] = React.useState("");
  const [lastTime, setLastTime] = React.useState(Date.now());
  const ref = useRef(null);

  function getCurrentDimension() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    }
  }

  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension());
    }

    window.addEventListener('resize', updateDimension);

    return(() => {
      window.removeEventListener('resize', updateDimension);
    });
  }, [screenSize]);

  const answerSelected = (value) => {
    setValue(value);
    if (ref.current) ref.current.className = "";

    let ratio = 0;
    let score = 0;
    if (props.quiz.answer === value) {
      ratio = 90;
    }

    const duration = (Date.now() - lastTime) / 1000 + 1;

    score = Math.pow(10, 1 / duration) * ratio;

    if (props.selectAnswer) props.selectAnswer(value, score);
    setSliderValue(0);
    setLastTime(Date.now());
  }

  const marks = props.quiz.options.map((answer, index) => {
    return {
      value: index,
      label: Number(answer),
    }
  })

  const handleSliderChange = (value) => {
    setSliderValue(props.quiz.options[value]);
  }

  useEffect(() => {
    setTimeout(() => {
      if (ref.current) {
        if (props.quizStep === 1 && props.quizMode === 2)
          return;
        if(!props.quiz.showLargeOptionsWithMap)
          ref.current.className = "zoomPic zoom";
        else
          ref.current.className = "zoomPicWithMap zoom";
      }
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.quiz, props.quizStep, props.quizMode]);


  const isMobile = useMediaQuery(useTheme().breakpoints.down("md"), {
    noSsr: true,
  });

  return (
    <>
      <Box
          sx={{
            textAlign:'left',
            width: '90%',
            marginTop: screenSize.width * 0.05 + "px",
            marginBottom: 2
          }}
      >
        <H5 fontWeight="bold" color={COLORS.white}>
          FRÅGA {props.quizStep + 1} AV 10
        </H5>
        <H3
          fontWeight="bold"
          color={COLORS.white}
          dangerouslySetInnerHTML={{ __html: props.quiz.question }}
        />
      </Box>

      {props.quiz.backgroundImageUrl &&
        !props.quiz.showMapOptions && !props.quiz.showLargeOptionsWithMap && (
          <Box
            className="zoomPic"
            ref={ref}
            style={{
              backgroundImage: `url('${props.quiz.backgroundImageUrl}'`,
              backgroundPosition: "50% 50%",
              width: "90%",
              height: isMobile ? screenSize.width * 0.9 * 0.57 + "px" : "300px",
              backgroundRepeat: "no-repeat",
              backgroundSize: isMobile ? `100% ${parseInt(screenSize.width*0.9*0.57)}px` : `100% 300px`,
              borderRadius: "20px",
              marginTop: 6,
            }}
          />
        )}

      {props.quiz.backgroundImageUrl &&
        props.quiz.showMapOptions && (
          <Box
            component="img"
            sx={{
              width: {
                xs: 150,
                md: 300,
              },
              height: {
                xs: 342,
                md: 685,
              },
            }}
            alt="menu"
            src={props.quiz.backgroundImageUrl}
          />
        )}

      {props.quiz.backgroundImageUrl &&
        props.quiz.showLargeOptionsWithMap && (
          <Box
            className="zoomPicWithMap"
            ref={ref}
            style={{
              backgroundImage: `url('${props.quiz.backgroundImageUrl}')`,
              backgroundPosition: "50% 50%",
              width: "90%",
              height: isMobile ? screenSize.width * 0.9 * 0.57 + "px" : "685px",
              backgroundRepeat: "no-repeat",
              backgroundSize: isMobile ? `100% ${parseInt(screenSize.width*0.9*0.57)}px`  : `100% 300px`,
              borderRadius: "10px",
            }}
          />
        )}

      {props.quiz.showMapOptions && (
        <FormControl>
          <RadioGroup
            name="controlled-radio-buttons-group"
            value={value}
            onChange={(event) => answerSelected(event.target.value)}
          >
            {props.quiz &&
              props.quiz.options.map((answer, index) => {
                return (
                  <FormControlLabel
                    sx={{
                      position: "absolute",
                      top: isMobile
                        ? props.quiz.positions[index].mobileTop
                        : props.quiz.positions[index].top,
                      left: isMobile
                        ? props.quiz.positions[index].mobileLeft
                        : props.quiz.positions[index].left,
                    }}
                    value={answer}
                    control={<Radio />}
                    label={answer}
                    labelPlacement={props.quiz.positions[index].placement}
                  />
                );
              })}
          </RadioGroup>
        </FormControl>
      )}

      {props.quiz.videoUrl && (
        <ReactPlayer
          className="quiz_video"
          url={props.quiz.videoUrl}
          controls={false}
          loop
          playing
          muted
          playsinline
          width={screenSize.width * 0.9 + "px"}
          height={screenSize.width * 0.9 * 0.57 + "px"}
        />
      )}

      <Box
          sx={{
            textAlign:'left',
            width: '90%',
            marginTop: 2.5
          }}
      >

      {props.quiz.showRadio && (
        <FormControl>
          <RadioGroup
            name="controlled-radio-buttons-group"
            value={value}
            onChange={(event) => answerSelected(event.target.value)}
          >
            {props.quiz &&
              props.quiz.options.map((answer, index) => {
                return (
                  <FormControlLabel
                    value={answer}
                    control={<Radio />}
                    label={answer}
                  />
                );
              })}
          </RadioGroup>
        </FormControl>
      )}
    </Box>

      {props.quiz.showSlider && (
        <Box
          sx={{
            width: { md: "50%", xs: "80%" },
            display: "flex",
          }}
        >
          <Slider
            aria-labelledby="track-false-slider"
            defaultValue={0}
            marks={marks}
            step={null}
            min={Number(marks[0].value)}
            max={Number(marks[marks.length - 1].value)}
            onChange={(e, val) => handleSliderChange(val)}
            onChangeCommitted={(e, val) => answerSelected(props.quiz.options[val])}
          />
          <Box
            sx={{
              background: COLORS.blue1,
              borderRadius: 1,
              width: 80,
              height: 30,
              marginLeft: 3,
              marginTop: "5px",
            }}
          >
            <H6
              fontWeight="bold"
              color={COLORS.white}
              fontFamily="'ATGRubrik'"
              marginTop="5px !important"
            >
              {sliderValue} {props.quiz.unit}
            </H6>
          </Box>
        </Box>
      )}

      {props.quiz && props.quiz.showTimeline && (
        <Timeline answerSelected={answerSelected} quiz={props.quiz} />
      )}

      {props.quiz && (props.quiz.showLargeOptions || props.quiz.showLargeOptionsWithMap) && (
        <LargeOption answerSelected={answerSelected} quiz={props.quiz} />
      )}
    </>
  );
};

export default QuizContent;
